import { UPDATE_SCALP_CAMERA_OPTION, GET_SCALP_CAMERA_GUIDE } from '../constants';
import { getContent } from '../../services/api';

/**
 * スカルプカメラアプリ使用可否を更新する
 */
export const updateScalpCameraOption = parameters => ({
  type: UPDATE_SCALP_CAMERA_OPTION,
  payload: parameters,
});

/**
 * スカルプカメラ・ダウンロードマニュアルを取得する
 */
export const getScalpCameraGuide = locale => ({
  type: GET_SCALP_CAMERA_GUIDE,
  payload: getContent({ contentType: 'scalpCameraDownload', locale }),
});



// WEBPACK FOOTER //
// ./src/redux/actions/scalpCameraOption.js